module.exports = require('./_global').document && document.documentElement;


// WEBPACK FOOTER //
// ./packages/emdb/node_modules/core-js/library/modules/_html.js